import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getUserCases, getExpireDate, } from '../../functions/utils'; // Import the utility function
import '../../css/ImportComponent.css';
import '../../css/ExactGlobeComponent.css';
import ImportHeaderComponent from './ImportHeaderComponent';
import DropdownComponent from '../utilities/DropdownComponent';
import OnPremiseAuthComponent from './OnPremiseAuthComponent';
import ListComponent from '../utilities/ListComponent';
import LoaderComponent from '../utilities/LoaderComponent';
import ExactGlobeLogo from '../../images/ExactGlobeLogo.png';
import { useTranslations  } from '../utilities/TranslationContext';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGears, faDatabase } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { handleImport, updateImportExactGlobe, deleteImport } from '../../functions/exactglobe';

// Add the icons you will use to the library
library.add(faGears, faDatabase);

const ExactGlobeSelectorComponent = () => {
  const { getTranslation, translations } = useTranslations();
  useEffect(() =>{

  },[]);

  useEffect(() =>{

  },[]);

  async function init(){

  }

  async function exact_globe_db(){
    window.location.href = "https://importmodule.factview.nl/app?import=exactglobe_db";
  }

  async function exact_globe_service(){
    window.location.href = "https://importmodule.factview.nl/app?import=exactglobe_service";
  }
  
  return (
    <div className="exact-globe-selector-container">  
    <ImportHeaderComponent
        title="Exact Globe Selector"
        logo={ExactGlobeLogo}
        subtitle={"Selecteer welke import methode u wilt gebruiken."}
        />
      <div className="exact-globe-selector">
        <div className="globe-select-option-container">
          <div className="globe-select-header">
            <div className="globe-select-logo">
              <FontAwesomeIcon className="globe-select-service-logo" icon={faGears}/>
            </div>
            <p>Globe Service Import</p>
          </div>
          <div className="globe-select-body">
            <div className="globe-select-desc">
              <p>Importeer gegevens via de portable Exact Globe Service server</p>
            </div>
            <div className="globe-select-button">
              <button className="import-component-btn hover" onClick={() => exact_globe_service()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div>
        </div>
        <div className="globe-select-option-container">
          <div className="globe-select-header">
            <div className="globe-select-logo">
              <FontAwesomeIcon className="globe-select-db-logo" icon={faDatabase}/>
            </div>
            <p>Globe Database Import</p>
          </div>
          <div className="globe-select-body">
            <div className="globe-select-desc">
              <p>Importeer gegevens via de portable Exact Globe Database server</p>
            </div>
            <div className="globe-select-button">
              <button className="import-component-btn hover" onClick={() => exact_globe_db()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExactGlobeSelectorComponent;
